function normalize(value) {
  return String(value).normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
}

export function matchesSearch(text, query) {
  const haystack = normalize(text);
  return normalize(query).split(' ').filter(Boolean).every(term => haystack.includes(term));
}

export function legacyArticleId(value) {
  try {
    const url = new URL(value);
    return `${url.hash} ${url.searchParams.get('hcUrl') || ''}`.match(/article-([a-zA-Z0-9_-]+)(?:\b|$)/)?.[1] || null;
  } catch {
    return null;
  }
}

if (typeof window !== 'undefined') {
  class ZeyaFaq extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        window.addEventListener('hashchange', this.openLinkedArticle);
        window.addEventListener('popstate', this.openLinkedArticle);
        this.openLinkedArticle();
        return;
      }
      this.ready = true;
      this.input = this.querySelector('[data-faq-search]');
      this.clear = this.querySelector('[data-faq-clear]');
      this.status = this.querySelector('[data-faq-status]');
      this.empty = this.querySelector('[data-faq-empty]');
      this.buttons = [...this.querySelectorAll('[data-faq-category]')];
      this.groups = [...this.querySelectorAll('[data-faq-group]')];
      this.articles = [...this.querySelectorAll('[data-faq-article]')];
      this.searchText = new Map(this.articles.map(article => [article, `${article.textContent} ${article.dataset.keywords || ''}`]));
      this.category = 'all';
      this.input.addEventListener('input', () => {
        if (this.input.value.trim()) this.category = 'all';
        this.filter();
      });
      this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.category = 'all';
        this.filter();
        this.input.focus();
      });
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Escape') this.clear.click();
      });
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.category = button.dataset.faqCategory;
        this.filter();
      }));
      this.articles.forEach(article => article.addEventListener('toggle', () => {
        if (!article.open) return;
        const url = new URL(window.location.href);
        url.hash = article.id;
        url.searchParams.delete('hcUrl');
        history.replaceState(null, '', url);
      }));
      this.openLinkedArticle = () => {
        const id = legacyArticleId(window.location.href);
        const article = this.articles.find(item => item.dataset.articleId === id);
        if (!article) return;
        this.input.value = '';
        this.category = article.dataset.category;
        this.filter();
        article.open = true;
        requestAnimationFrame(() => article.scrollIntoView({ block: 'start', behavior: 'instant' }));
      };
      window.addEventListener('hashchange', this.openLinkedArticle);
      window.addEventListener('popstate', this.openLinkedArticle);
      this.filter();
      this.openLinkedArticle();
      this.classList.add('is-ready');
    }

    filter() {
      const query = this.input.value;
      let count = 0;
      this.articles.forEach(article => {
        const visible = (this.category === 'all' || this.category === article.dataset.category) && matchesSearch(this.searchText.get(article), query);
        article.hidden = !visible;
        if (visible) count++;
      });
      this.groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-faq-article]')].some(article => !article.hidden); });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.faqCategory === this.category)));
      this.clear.hidden = !query;
      this.empty.hidden = count !== 0;
      this.status.textContent = (count === 1 ? this.dataset.resultOne : this.dataset.resultMany).replace('{count}', String(count));
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.openLinkedArticle);
      window.removeEventListener('popstate', this.openLinkedArticle);
    }
  }
  if (!customElements.get('zeya-faq')) customElements.define('zeya-faq', ZeyaFaq);
}
